<template>
  <v-autocomplete ref="auto" v-model="selected" :items="personas" :search-input.sync="filtro" item-value="id" 
    item-text="nombre" :label="label || 'Ingrese un valor'" :loading="loading" :error="!!error"
    :hint="personaDescripcion || error" persistent-hint clearable hide-details @keydown.native="onInput" @change="onSelect"  @keydown.esc.stop.prevent="onCancel"  @blur="onCancel">
  </v-autocomplete>

</template>

<script>
import PersonaService from '../../services/Persona.service'

export default {
  props: {
    value: [String, Number],
    label: String
  },

  data() {
    return {
      filtro: '',
      personas: [],
      selected: null,
      loading: false,
      error: '',
      debounceTimer: null,
      edit: false,
    }
  },

  watch: {
    filtro(val) {
      console.log({ sd: this.selected, val, filtro: this.filtro });


      if (this.selected) return;
      if (!val) {
        this.reset()
        return
      }

      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.buscarPersona(val)
      }, 400)
    },

    value(val) {
      if (!val) {
        this.reset()
        return
      }

      this.filtro = String(val)
    }
  },

  computed: {
    personaDescripcion() {
      if (this.personas.length !== 1) return ''
      const p = this.personas[0]
      return `${p.nombre || ''}`
    }
  },

  methods: {
    onCancel() {
      this.$emit("cancel");
    },
    onInput(e) {
      // cualquier tecla que modifique texto
      const teclasValidas = [
        'Backspace',
        'Delete',
        ' '
      ]
      console.log(this.selected);
      if (teclasValidas.includes(e.key) || e.key.length === 1) {
        this.selected = null
        this.$emit('input', null)
      }
    },
    async buscarPersona(valor) {
      this.loading = true
      this.error = ''
      this.personas = []

      try {
        const res = await PersonaService.ObtenerDocente(valor)
        this.personas = res.data || []

        // 🔥 un solo resultado → autoselección
        if (this.personas.length === 1) {
          this.selectPersona(this.personas[0])
          this.closeMenu()
          return
        }

        /* // 🔥 match exacto → autoselección
        const exact = this.personas.find(
          p => String(p.id) === String(valor)
        )

        if (exact) {
          this.selectPersona(exact)
          this.closeMenu()
        } */

      } catch (e) {
        this.error = 'Datos inválidos'
        this.reset()
      } finally {
        this.loading = false
      }
    },

    onSelect(id) {
      const persona = this.personas.find(p => p.id === id)
      if (!persona) return
      this.selectPersona(persona)
    },

    selectPersona(persona) {
      this.selected = persona.id
      this.$emit('input', persona.id)
      if(this.edit){
        this.edit=false;
        return;
      }
      this.$emit('personas:change', persona)
    },

    reset() {

      if (this.selected) {
        this.selected = null
        this.personas = []
        this.$emit('input', null)
        this.$emit('personas:change', null)
      }
    },

    closeMenu() {
      this.$nextTick(() => {
        if (this.$refs.auto) {
          this.$refs.auto.isMenuActive = false
        }
      })
    }
  },

  mounted() {

    if (this.value) {

      this.edit=true;
      this.filtro = String(this.value)
      this.$nextTick(() => {
      // v-text-field
      if (this.$refs.auto) {
        const el = this.$refs.auto.$el.querySelector("input");
        if (el) {
          el.focus();
          el.select();
        }
        return;
      }
    });
      // this.buscarPersona(this.filtro)
    }
  }
}
</script>

<style scoped></style>

<!-- <template>
  <div>
    <v-form @submit.prevent="buscarPersona" class="d-flex justify-center align-center">
      <v-text-field class @blur="buscarPersona" :label="label || 'Ingrese un valor '" v-model="filtro"
        :hint="personaDescripcion || error" persistent-hint :error="!!error" :loading="loading"></v-text-field>
    </v-form>
  </div>
</template>

<script>
import PersonaService from '../../services/Persona.service'
export default {
  props: ["value", "label"],

  data() {
    return {
      error: "",
      filtro: "",
      personas: null,
      loading: false,
    };
  },
  watch: {
    value(val) {
      if (val) {
        console.log("wvalue", val);
        this.filtro = val;
        this.buscarPersona();
      } else {
        this.filtro = "";
        this.personas = null;
      }
    },
  },
  computed: {
    personaDescripcion: function () {
      if (!this.personas||this.personas.length > 1) return "";
      return (
        this.personas[0].apellido +
        " " +
        (this.personas[0].nombre===undefined ?'':this.personas[0].nombre)
      );
    },
  },
  methods: {
    buscarPersona() {
      if (this.filtro && this.filtro != "") {
        this.error = "";
        this.personas = null;
        this.loading = true;
        PersonaService.ObtenerDocente(this.filtro)
          .then((res) => {
            if(res.data.length>0){
              console.log(res.data);
              this.personas = res.data;
              this.$emit("input", +this.filtro);
              this.$emit('personas:change', this.personas);
            }
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
            this.error = "Datos inválidos";
            this.$emit("input", null);
            this.$emit('personas:change', null);
          });
      } else {
        this.filtro = "";
        this.personas = null;
        this.$emit("input", null);
        this.$emit('personas:change', null);
      }
    },
  },
  mounted() {
    this.filtro = this.value;
    this.buscarPersona();
   },
};
</script>

<style lang="scss" scoped>
</style> -->